(function () {
  'use strict';

  function applyFilter(root, filterValue) {
    var cards = root.querySelectorAll('[data-nr-tag]');

    cards.forEach(function (card) {
      var tags = (card.getAttribute('data-nr-tag') || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      var show = filterValue === 'all' || tags.indexOf(filterValue) !== -1;
      card.classList.toggle('is-hidden', !show);
    });
  }

  function setActiveButton(buttons, activeBtn) {
    buttons.forEach(function (btn) {
      var isActive = btn === activeBtn;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function sortCards(root) {
    var grid = root.querySelector('.nr-everyone-ive-worked-with__grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-nr-sort]'));
    if (cards.length < 2) return;

    cards.sort(function (a, b) {
      return Number(a.getAttribute('data-nr-sort') || 0) - Number(b.getAttribute('data-nr-sort') || 0);
    });
    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function initSection(root) {
    sortCards(root);

    var filterButtons = root.querySelectorAll('[data-nr-filter]');
    if (!filterButtons.length) return;

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filterValue = btn.getAttribute('data-nr-filter') || 'all';
        setActiveButton(filterButtons, btn);
        applyFilter(root, filterValue);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-nr-everyone-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
